import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ScheduleComponent } from './v1/schedule.component';
import { NzFormModule } from 'ng-zorro-antd/form';
import { NzInputModule } from 'ng-zorro-antd/input';
import { NzDatePickerModule } from 'ng-zorro-antd/date-picker';
import { NzGridModule } from 'ng-zorro-antd/grid';
import { NzTimePickerModule } from 'ng-zorro-antd/time-picker';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { MinsToDatePipe, MinsToTimePipe } from './minsToTime.pipe';
import { NzToolTipModule } from 'ng-zorro-antd/tooltip';
import { NzCheckboxModule } from 'ng-zorro-antd/checkbox';
import { NzDividerModule } from 'ng-zorro-antd/divider';
import { NzTableModule } from 'ng-zorro-antd/table';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzPageHeaderModule } from 'ng-zorro-antd/page-header';
import { NzInputNumberModule } from 'ng-zorro-antd/input-number';
import { NzSelectModule } from 'ng-zorro-antd/select';
import { NzSpinModule } from 'ng-zorro-antd/spin';
import { ScheduleCalendarComponent } from './schedule-calendar/schedule-calendar.component';
import { ScheduleModule as ej2ScheduleModule } from '@syncfusion/ej2-angular-schedule';
import { NzModalModule } from 'ng-zorro-antd/modal';
import { NzRadioModule } from 'ng-zorro-antd/radio';
import { NzPopconfirmModule } from 'ng-zorro-antd/popconfirm';
import { NzAlertModule } from 'ng-zorro-antd/alert';

@NgModule({
  declarations: [
    ScheduleComponent,
    MinsToTimePipe,
    MinsToDatePipe,
    ScheduleCalendarComponent
  ],
  providers: [],
  imports: [
    NzTimePickerModule,
    CommonModule,
    NzInputModule,
    NzInputNumberModule,
    ReactiveFormsModule,
    NzDatePickerModule,
    NzFormModule,
    NzGridModule,
    FormsModule,
    NzIconModule,
    NzToolTipModule,
    NzCheckboxModule,
    NzDividerModule,
    NzTableModule,
    NzButtonModule,
    NzPageHeaderModule,
    NzSelectModule,
    NzSpinModule,
    ej2ScheduleModule,
    NzModalModule,
    NzRadioModule,
    NzPopconfirmModule,
    NzAlertModule
  ],
  exports: [ScheduleComponent]
})
export class ScheduleModule {}
